export const FeatureFlags = {
  newShareExperience: 'react-share-experience',
  sso: 'single-sign-on',
  crmDataFlexibility: 'crm-data-flexibility',
  documentSettings: 'document-settings',
  multiaccounts: 'account-multi-access',
  prismatic: 'prismatic',
  collaboratorSeats: 'collaborator-seats',
  exclusiveFlowV3: 'exclusive-flow-v3',
  connectApi: 'connect-api',
  pdfImport: 'pdf-import',
  pdfImportNativePdf: 'pdf-import-native-pdf',
  currencySettings: 'currency-settings',
  usersAndPermissions: 'users-permissions',
  pageOrientationSettings: 'page-orientation-settings',
  autoReminders: 'auto-reminders',
  integrationsV3: 'integrations-v3',
  aiCustomEditorPrompt: 'ai-custom-editor-prompt',
  alignmentLines: 'alignment-lines',
  contactsPage: 'contacts-companies-page',
  commentingOnTable: 'sp-table-commenting',
  publishV3Templates: 'publish-v3-templates',
  prosperStackTestMode: 'prosperstack-test-mode',
  tryV3: 'try-v3',
  userGroups: 'user-groups',
  permissionsEnforcement: 'permissions-enforcement',
  userManagement: 'user-management',
  createSampleDocument: 'sample-document',
  crmDealLinking: 'crm-deal-linking',
  useVariablesBff: 'use-variables-bff',
  aiInferenceService: 'AI-Inference-Service',
  aiChatSidePannel: 'ai-chat-side-pannel',
  editorRemote: 'editor-remote',
  approvalWorkflows: 'approval-workflows',
  gettingStartedPage: 'getting-started-page',
  crmPricingEmbed: 'crm-pricing-embed',
  crmPricingGroupRow: 'crm-pricing-group-row',
  crmVariablesV2Route: 'crm-variables-v2-route',
  appNativeVariablesV2Route: 'app-native-variables-v2-route',
  sheetsExcelEmbed: 'sheets-excel-embed',
  pricingCatalog: 'pricing-catalog',
  imageCrop: 'image-crop',
  v2VariableRoutes: 'v2-variable-routes',
} as const;

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];
